var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notToast)?_c('div',{staticClass:"modal-wrap"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"show-wrap"},[_c('div',{staticClass:"show-logo"}),_c('p',{staticClass:"show-text"},[_vm._v(_vm._s(_vm.ToastText))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }